import { C } from "../../lib/constants";

export const Av = ({letters, color, size=48, dot=null}) => {
  const isImage = typeof letters === "string" && /^https?:\/\//i.test(letters);
  return (
    <div style={{position:"relative",flexShrink:0}}>
      <div style={{
        width:size,height:size,borderRadius:size*0.28,
        background:`linear-gradient(135deg,${color},${color}BB)`,
        display:"flex",alignItems:"center",justifyContent:"center",
        fontSize:size*0.36,fontWeight:800,color:"#fff",
        fontFamily:"'Georgia',serif",boxShadow:`0 2px 8px ${color}40`,overflow:"hidden"
      }}>
        {isImage
          ? <img src={letters} alt="Perfil" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
          : letters}
      </div>
      {dot!==null&&<div style={{position:"absolute",bottom:-1,right:-1,width:13,height:13,borderRadius:"50%",background:dot?C.green:"#CCC",border:`2px solid ${C.surface}`}}/>}
    </div>
  );
};
